import { ContextLanguage } from "../../../context/Context.Language";
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  RETURN_TIME,
  TEXT_AFTERYOU_FIRST_ORDER_BKK,
  TEXT_ALSO_AVAILABLE_IN_BKK,
  TEXT_ALSO_AVAILABLE_IN_PATTAYA,
  TEXT_AND,
  TEXT_AN_ORDER_NOW,
  TEXT_ASAP_CAN_STILL,
  TEXT_AS_A_PREMIUM_SHOE_CLEANING_BKK,
  TEXT_AS_PROFESSIONAL_SHOS_WASHING_BKK,
  TEXT_CLEANING_SERVICE_IN_BKK,
  TEXT_CLEANING_SERVICE_IN_BKK_2,
  TEXT_CLEANING_SERVICE_IN_BKK_3,
  TEXT_CREATE,
  TEXT_FOR_ULTIMATE_SHOE_CLEANING,
  TEXT_GOOD_TO_KNOW,
  TEXT_HAVE_PACKAGES,
  TEXT_HEY_DO_YOU_KNOW_BKK,
  TEXT_HOW_IT_WORKS_IN_BKK,
  TEXT_IF_YOU_WISH_YOUR_ITEMS2,
  TEXT_IRON,
  TEXT_ITEMS_OF_CLOTHING_TOWELS,
  TEXT_LAUNDRY_SERVICE_BKK_HEAD,
  TEXT_MY_LAUNDRY,
  TEXT_NEAR_YOU_IN_BKK,
  TEXT_NO_SURPRIZES_BKK,
  TEXT_OFFER_YOU_TREE_SHOES,
  TEXT_OF_SHOES_AT_A_FIXED,
  TEXT_OR,
  TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_2,
  TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_3,
  TEXT_OUR_PROFESSIONAL_LAUNDRY_BKK_3,
  TEXT_OUR_PROFSSIONAL_LAUNDRY_SERVICE,
  TEXT_PACKAGES,
  TEXT_PACKAGES_OFFER_YOU,
  TEXT_PAIR,
  TEXT_PAIRS,
  TEXT_PIECE,
  TEXT_PRICE_NO_S,
  TEXT_PROTECTION_WATERPROOF,
  TEXT_PS_BKK,
  TEXT_SHOES_CLEANING_BKK,
  TEXT_THE,
  TEXT_WASH_IRON_CLEAN,
  TEXT_WE_PROVIDE_OUR_SERVICE_IN_BKK,
  TEXT_WHETHER_YOU_SELECT,
  TEXT_WITH_VARIOUS_ADD_ONS,
  TEXT_YOU_CAN_JUST_FILL_UP,
  TEXT_YOU_WILL_PAY_PTY,
  TEXT_YOU_WILL_RECEIVE,
  TEXT_YOU_WILL_RECEIVE_EN,
  TIME_STRING_ENG,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_2_REGULAR,
  STYLE_HEADING_2,
  STYLE_IMG_BKK,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
  STYLE_PADDING_WINDOWS,
  STYLE_PARENT_GRID_BKK,
  STYLE_UNDERLINE_BLUE_24_16,
  STYLE_WASH_IRON_CLEAN_HOME_WELCOME,
} from "../../../utils/useStyle";
import React from "react";
import { useNavigate } from "react-router-dom";
import HomeClickToProgram from "../../home/functions/Home.ClickToProgram";
import { FunctionFormattedData } from "../../../utils/useFunction";

const Section1 = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const Text = () => {
    return (
      <div>
        <div className={`${STYLE_HEADING_2(language)} text-center`}>
          {TEXT_HOW_IT_WORKS_IN_BKK[language]}
        </div>
        <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
        <div className={`${STYLE_WASH_IRON_CLEAN_HOME_WELCOME(language)}`}>
          {TEXT_WASH_IRON_CLEAN[language]}
        </div>
        <div
          className={`${
            language === "TH"
              ? " text-sm-th md:text-base-th "
              : " text-sm md:text-base "
          } text-center text-laundry-primary-blue  flex justify-center pt-[4px] leading-6 mt-1`}
        >
          <div> {TEXT_ALSO_AVAILABLE_IN_PATTAYA[language]}</div>
        </div>
        <div
          className={` mt-4 md:mt-8.5 text-center text-laundry-gray-100 ${STYLE_BODY_2_REGULAR(
            language
          )} `}
        >
          {TEXT_WHETHER_YOU_SELECT[language]}
          <span
            onClick={() =>
              // HomeClickToProgram(
              //   navigate,
              //   "My Wash",
              //   "6310a054f095c39af2b7503e"
              // )
              navigate("/MyWash")
            }
            className={STYLE_LINK_BLUE}
          >
            My Wash
          </span>
          <span className="-ml-1">,</span>
          <span
            onClick={() =>
              // HomeClickToProgram(
              //   navigate,
              //   "My Iron",
              //   "6310a3cff095c39af2b75041"
              // )
              navigate("/MyIron")
            }
            className={STYLE_LINK_BLUE}
          >
            My Iron
          </span>
          {TEXT_OR[language]}
          {isMobile ? (
            <div>
              <span
                onClick={() =>
                  // HomeClickToProgram(
                  //   navigate,
                  //   "My Shoes",
                  //   "6310a3d1f095c39af2b75045"
                  // )
                  navigate("/MyShoes")
                }
                className={STYLE_LINK_BLUE}
              >
                My Shoes
              </span>
              {/* {TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_2[language]} */}
              {language === "TH" ? (
                <span>
                  บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร
                  สะดวกในการสั่งออเดอร์
                  รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
                  {isMobile ? (
                    <br />
                  ) : (
                    ""
                  )}เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน{" "}
                  {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. {isMobile ? <br /> : ""}
                  เราจะไปรับในวันเดียวกันและส่งคืนภายใน {RETURN_TIME}:00 น.
                  {isMobile ? <br /> : ""} ของวันถัดไป สะดวกและรวดเร็ว!
                  เร็วกว่านี้ได้ไหม? {isMobile ? <br /> : ""}เฉพาะในกรุงเทพฯ
                  แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
                  {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน
                  {isMobile && <br />}ออเดอร์ภายใน{" "}
                  {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.
                </span>
              ) : (
                `our professional laundry service as well as our shoe cleaning service are fully customisable to meet all your requirements in a one-stop solution. Giving you the utmost flexibility and convenience, our services are as easy as ordering food or shopping online. We guarantee: All orders placed by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day and returned by 12:00 the next day - fast & easy! You want it faster? In Bangkok only - Activate our Same Day Express Service before ${TIME_THAT_STILL_SAME_DAY_SERVICE}:00 ${TIME_STRING_ENG}, and your items will be picked up and returned by ${LAST_TIME_YOU_STILL_CAN_BOOK}:00`
              )}
              <div>
                <div>
                  {TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_3[language]}
                  <span
                    onClick={() => navigate("/OurServices")}
                    className={STYLE_LINK_BLUE}
                  >
                    {TEXT_CREATE[language]}
                  </span>
                  {TEXT_AN_ORDER_NOW[language]}
                </div>
              </div>
            </div>
          ) : (
            <span>
              <span
                onClick={() =>
                  // HomeClickToProgram(
                  //   navigate,
                  //   "My Shoes",
                  //   "6310a3d1f095c39af2b75045"
                  // )
                  navigate("/MyShoes")
                }
                className={STYLE_LINK_BLUE}
              >
                My Shoes
              </span>
              {/* {TEXT_OUR_PROFSSIONAL_LAUNDRY_SERVICE[language]} */}
              <div>
                {language === "TH" ? (
                  <span>
                    บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร
                    สะดวกในการสั่งออเดอร์
                    รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
                    เรารับประกันว่าทุก ออเดอร์ที่สั่งภายใน{" "}
                    {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.
                    เราจะไปรับในวันเดียวกันและส่งคืนภายใน {RETURN_TIME}:00 น.
                    ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม?
                    เฉพาะในกรุงเทพฯ แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
                    {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน
                    ออเดอร์ภายใน {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น.
                    ของวันเดียวกัน
                  </span>
                ) : (
                  <span>
                    our professional laundry service as well as our shoe
                    cleaning service are fully customisable to meet all your
                    requirements in a one-stop solution. Giving you the utmost
                    flexibility and convenience, our services are as easy as
                    ordering food or shopping online. We guarantee: All orders
                    placed by {LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked
                    up on the same day and returned by {RETURN_TIME}:00 the next
                    day - fast & easy! You want it faster? In Bangkok only -
                    Activate our Same Day Express Service before{" "}
                    {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 {TIME_STRING_ENG}, and
                    your items will be picked up and returned by{" "}
                    {LAST_TIME_YOU_STILL_CAN_BOOK}:00 on the same day.
                  </span>
                )}
              </div>
              <div>
                <span
                  onClick={() => navigate("/OurServices")}
                  className={STYLE_LINK_BLUE}
                >
                  {TEXT_CREATE[language]}
                </span>
                {TEXT_AN_ORDER_NOW[language]}
              </div>
            </span>
          )}

          {/* <span>{TEXT_OUR_PROFESSINAL_LANDRY_SERVICE_2[language]}</span> */}
          {/* <div>{TEXT_OUR_PROFESSIONAL_LAUNDRY_BKK_3[language]}</div> */}
        </div>
      </div>
    );
  };
  return (
    <div
      className={` my-4 md:mt-13.5 py-6.5 md:py-13.5 md:mb-13.5 bg-laundry-bglight  `}
    >
      <div className={`${STYLE_PADDING_WINDOWS} ${STYLE_MAX_WIDTH_DESKTOP}`}>
        {isMobile ? (
          <React.Fragment>
            <img
              src="/images/img_pattaya_1.png"
              className=" w-img_howitwork_mb mx-auto mb-4"
            />
            <Text />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={STYLE_PARENT_GRID_BKK}>
              <Text />
              <img src="/images/img_pattaya_1.png" className={STYLE_IMG_BKK} />
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
const Section2 = ({ thisData }) => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  console.log("thisData", thisData);
  const Text = () => {
    if (!thisData) return null;
    return (
      <div>
        <div className={`${STYLE_HEADING_2(language)} text-center`}>
          {TEXT_LAUNDRY_SERVICE_BKK_HEAD[language]}
        </div>
        <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
        <div
          className={` mt-4 md:mt-8.5 text-center text-laundry-gray-100 space-y-6 ${STYLE_BODY_2_REGULAR(
            language
          )} `}
        >
          <div>
            {TEXT_NO_SURPRIZES_BKK[language]}
            <span
              onClick={() => navigate("/Pricing")}
              className={STYLE_LINK_BLUE}
            >
              {TEXT_PRICE_NO_S[language]}
            </span>
            {TEXT_YOU_WILL_PAY_PTY[language]}
          </div>
          <div>
            {TEXT_THE[language]}
            <span className="font-semibold"> My Wash </span>
            {TEXT_HAVE_PACKAGES[language]}
            {/* <span className="font-semibold">S, M </span>
            {TEXT_AND[language]}
            <span className="font-semibold"> L </span> */}
            {TEXT_PACKAGES_OFFER_YOU[language]}
            {language === "EN" ? (
              <React.Fragment>
                {isMobile ? (
                  <span>
                    <br />
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_s}
                    </span>
                    {language === "TH" ? ` ${thisData[0]?.unit_s_th}, ` : ", "}
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_m}{" "}
                    </span>
                    {language === "TH" ? ` ${thisData[0]?.unit_m_th} ` : ""}
                    {TEXT_AND[language]}
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_l}{" "}
                    </span>
                    {language === "TH"
                      ? ` ${thisData[0]?.unit_l_th} `
                      : ` ${thisData[0]?.unit_l} `}
                    {TEXT_ITEMS_OF_CLOTHING_TOWELS[language]}
                    {/* <div>– with no surprises. You can customise</div> */}
                  </span>
                ) : (
                  <span>
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_s}
                    </span>
                    {language === "TH" ? ` ${thisData[0]?.unit_th_s}, ` : ", "}
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_m}{" "}
                    </span>
                    {language === "TH" ? ` ${thisData[0]?.unit_th_m} ` : ""}
                    {TEXT_AND[language]}
                    <span className="font-semibold">
                      {" "}
                      {thisData[0]?.amount_l}{" "}
                    </span>
                    {language === "TH"
                      ? ` ${thisData[0]?.unit_th_l} `
                      : ` ${thisData[0]?.unit_l} `}
                    {TEXT_ITEMS_OF_CLOTHING_TOWELS[language]}
                  </span>
                )}
              </React.Fragment>
            ) : (
              <span>
                <span className="font-semibold"> {thisData[1]?.amount_s}</span>
                {language === "TH" ? ` ${thisData[0]?.unit_th_s}, ` : ", "}
                <span className="font-semibold"> {thisData[0]?.amount_m} </span>
                {language === "TH" ? ` ${thisData[0]?.unit_th_m} ` : ""}
                {TEXT_AND[language]}
                <span className="font-semibold"> {thisData[0]?.amount_l} </span>
                {language === "TH"
                  ? ` ${thisData[0]?.unit_th_l} `
                  : ` ${thisData[0]?.unit_l} `}
                {TEXT_ITEMS_OF_CLOTHING_TOWELS[language]}
              </span>
            )}
            <span className="font-semibold"> My Wash </span>
            {TEXT_WITH_VARIOUS_ADD_ONS[language]}
            <span className="font-semibold"> {TEXT_IRON[language]} </span>
            {/* <span> {TEXT_IF_YOU_WISH_YOUR_ITEMS[language]}</span> */}
            <span>{TEXT_IF_YOU_WISH_YOUR_ITEMS2[language]}</span>
            {TEXT_PS_BKK[language]}
          </div>
          <div>
            <span className="font-semibold">{TEXT_GOOD_TO_KNOW[language]}</span>
            {TEXT_AFTERYOU_FIRST_ORDER_BKK[language]}
            {isMobile ? (
              <div>{TEXT_YOU_WILL_RECEIVE_EN[language]}</div>
            ) : (
              <span>{TEXT_YOU_WILL_RECEIVE_EN[language]}</span>
            )}
            <div>
              {TEXT_YOU_WILL_RECEIVE[language]}
              <span className="font-semibold">
                {TEXT_YOU_CAN_JUST_FILL_UP[language]}
              </span>
              {TEXT_ASAP_CAN_STILL[language]}
              <span
                onClick={() => navigate("/OurServices")}
                className={STYLE_LINK_BLUE}
              >
                {TEXT_CREATE[language]}
              </span>
              {TEXT_AN_ORDER_NOW[language]}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={` my-10 py-4 md:py-13.5 md:my-0 ${STYLE_PADDING_WINDOWS} ${STYLE_MAX_WIDTH_DESKTOP}`}
    >
      <div className={STYLE_PARENT_GRID_BKK}>
        <img src="/images/img_pattaya_2.png" className={STYLE_IMG_BKK} />
        <Text />
      </div>
    </div>
  );
};
const NearYou = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  return (
    <div
      className={` pt-6.5 pb-2 md:pb-0 md:pt-13.5  ${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP} `}
    >
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_NEAR_YOU_IN_BKK[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div className={` ${STYLE_BODY_2_REGULAR(language)} text-center `}>
        {TEXT_WE_PROVIDE_OUR_SERVICE_IN_BKK[language]}
        <span
          onClick={() => navigate("/OurServices")}
          className={STYLE_LINK_BLUE}
        >
          {TEXT_CREATE[language]}
        </span>
        {TEXT_AN_ORDER_NOW[language]}
      </div>
    </div>
  );
};

const ShoeClean = ({ thisData }) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div
      className={`mt-10 ${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP}`}
    >
      <div className={`${STYLE_HEADING_2(language)} text-center font-bold`}>
        {TEXT_SHOES_CLEANING_BKK[language]}
      </div>
      <div
        className={` mt-4 md:mt-8.5 text-center text-laundry-gray-100 space-y-6 ${STYLE_BODY_2_REGULAR(
          language
        )} `}
      >
        <div>
          {TEXT_THE[language]}
          <span className="font-semibold"> My Shoes </span>
          {TEXT_HAVE_PACKAGES[language]}
          <span className="font-semibold"> {TEXT_PACKAGES[language]}</span>

          {TEXT_OFFER_YOU_TREE_SHOES[language]}
          <span className="font-semibold">
            {" "}
            {thisData[2]?.amount_s}{" "}
            {language === "TH" ? thisData[2]?.unit_th_s : thisData[2]?.unit_s},
          </span>
          <span className="font-semibold">
            {" "}
            {thisData[2]?.amount_m}{" "}
            {language === "TH" ? thisData[2]?.unit_th_m : thisData[2]?.unit_m}{" "}
          </span>
          {TEXT_OR[language]}
          <span className="font-semibold">
            {" "}
            {thisData[2]?.amount_l}{" "}
            {language === "TH" ? thisData[2]?.unit_th_l : thisData[2]?.unit_l}{" "}
          </span>

          {TEXT_OF_SHOES_AT_A_FIXED[language]}
          {isMobile ? (
            <div>
              <span className="font-semibold"> My Shoes </span>
              {TEXT_WITH_VARIOUS_ADD_ONS[language]}
              <span className="font-semibold">
                {" "}
                {TEXT_PROTECTION_WATERPROOF[language]}{" "}
              </span>
              {TEXT_FOR_ULTIMATE_SHOE_CLEANING[language]}
            </div>
          ) : (
            <span>
              <span className="font-semibold"> My Shoes </span>
              {TEXT_WITH_VARIOUS_ADD_ONS[language]}
              <span className="font-semibold">
                {" "}
                {TEXT_PROTECTION_WATERPROOF[language]}{" "}
              </span>
              {TEXT_FOR_ULTIMATE_SHOE_CLEANING[language]}
            </span>
          )}
        </div>

        <div>
          <span className="font-semibold">{TEXT_GOOD_TO_KNOW[language]} </span>
          {TEXT_AS_A_PREMIUM_SHOE_CLEANING_BKK[language]}
          {TEXT_AS_PROFESSIONAL_SHOS_WASHING_BKK[language]}
        </div>
      </div>
    </div>
  );
};

const WantToKnowMore = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div
      className={`mt-10 md:mt-13.5 ${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP}`}
    >
      <div className={`${STYLE_HEADING_2(language)} text-center font-bold`}>
        {TEXT_HEY_DO_YOU_KNOW_BKK[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div className={`${STYLE_BODY_2_REGULAR(language)} text-center`}>
        {language === "TH" ? "ใช่" : "Yes,"}
        <span className="font-semibold mx-1">{TEXT_MY_LAUNDRY[language]}</span>

        {isMobile ? (
          <span>
            {TEXT_CLEANING_SERVICE_IN_BKK_2[language]}
            <span>
              {" "}
              {TEXT_CLEANING_SERVICE_IN_BKK_3[language]}
              <br />
              <span
                className={STYLE_LINK_BLUE}
                onClick={() => navigate("/OurServices")}
              >
                {TEXT_CREATE[language]}
              </span>
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            </span>
          </span>
        ) : (
          <span>
            {TEXT_CLEANING_SERVICE_IN_BKK[language]}
            <span
              className={STYLE_LINK_BLUE}
              onClick={() => navigate("/OurServices")}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </span>
        )}
      </div>
    </div>
  );
};

const BangkokList = ({ programs, data }) => {
  let thisData = programs?.map((e) => {
    let self = data?.addons
      ?.filter((f) => f?.master_id === e?._id && f?.type === "PACKAGE")
      ?.map((g) => {
        return {
          size: g?.size,
          amount: g?.amount,
          unit: g?.unit,
          unit_th: g?.unit_th,
        };
      });

    const thisResult = FunctionFormattedData({ addon: self });

    return {
      ...e,
      ...thisResult,
    };
  });

  return (
    <div>
      <NearYou />
      <Section1 />
      <Section2 thisData={thisData} />
      <ShoeClean thisData={thisData} />
      <WantToKnowMore />
    </div>
  );
};
export default BangkokList;
